module.exports = __webpack_public_path__ + "static/ultra_0-94675ed1d008a137f413c965387fdd7d.jpg";